import { SKIN_TONE_MODIFIERS } from '../components/pages/CreatePage/CreatePageConstants';
export const EMOJI_CDN_BASE_PATH = 'https://specterr.b-cdn.net/emoji';

export function getEmojiImagePath(unicodeId) {
    if (!unicodeId) return null;
    return `${EMOJI_CDN_BASE_PATH}/${unicodeId}.png`;
}

export function getUnicodeIdFromEmojiUrl(emojiUrl) {
    if (!emojiUrl) return null;
    const match = emojiUrl.match(/\/([^/]+)\.png$/);
    return match ? match[1] : null;
}

export function getSkinToneVariations(baseUnicodeId) {
    if (!baseUnicodeId) return [];
    
    return [
        { unicode: baseUnicodeId, label: 'Default' },
        { unicode: `${baseUnicodeId}-${SKIN_TONE_MODIFIERS.LIGHT}`, label: 'Light' },
        { unicode: `${baseUnicodeId}-${SKIN_TONE_MODIFIERS.MEDIUM_LIGHT}`, label: 'Medium-Light' },
        { unicode: `${baseUnicodeId}-${SKIN_TONE_MODIFIERS.MEDIUM}`, label: 'Medium' },
        { unicode: `${baseUnicodeId}-${SKIN_TONE_MODIFIERS.MEDIUM_DARK}`, label: 'Medium-Dark' },
        { unicode: `${baseUnicodeId}-${SKIN_TONE_MODIFIERS.DARK}`, label: 'Dark' }
    ];
}
